import React from 'react';
import { Link } from 'react-router-dom';

// Social icons as components
const FacebookIcon = () => (
  <svg fill="currentColor" height="20" width="20" viewBox="0 0 256 256" xmlns="http://www.w3.org/2000/svg">
    <path d="M128,24A104,104,0,1,0,232,128,104.11,104.11,0,0,0,128,24Zm8,191.63V152h24a8,8,0,0,0,0-16H136V112a16,16,0,0,1,16-16h16a8,8,0,0,0,0-16H152a32,32,0,0,0-32,32v24H96a8,8,0,0,0,0,16h24v63.63a88,88,0,1,1,16,0Z"></path>
  </svg>
);

const InstagramIcon = () => (
  <svg fill="currentColor" height="20" width="20" viewBox="0 0 256 256" xmlns="http://www.w3.org/2000/svg">
    <path d="M128,80a48,48,0,1,0,48,48A48.05,48.05,0,0,0,128,80Zm0,80a32,32,0,1,1,32-32A32,32,0,0,1,128,160ZM176,24H80A56.06,56.06,0,0,0,24,80v96a56.06,56.06,0,0,0,56,56h96a56.06,56.06,0,0,0,56-56V80A56.06,56.06,0,0,0,176,24Zm40,152a40,40,0,0,1-40,40H80a40,40,0,0,1-40-40V80A40,40,0,0,1,80,40h96a40,40,0,0,1,40,40ZM192,76a12,12,0,1,1-12-12A12,12,0,0,1,192,76Z"></path>
  </svg>
);

const Footer = () => {
  const scrollToTop = () => window.scrollTo({ top: 0, behavior: 'smooth' });

  const QUICK_LINKS = [
    { name: 'About Us', path: '/about' },
    { name: 'Academics', path: '/academics' },
    { name: 'Admissions', path: '/admissions' },
    { name: 'Facilities', path: '/facilities' },
    { name: 'Gallery', path: '/gallery' },
    { name: 'Careers', path: '/careers' },
    { name: 'Contact Us', path: '/contact' },
  ];

  const SOCIAL_LINKS = [
    { href: 'https://www.facebook.com/anestargroup/', label: 'Facebook', icon: <FacebookIcon /> },
    { href: 'https://www.instagram.com/anestar_group_of_schools/', label: 'Instagram', icon: <InstagramIcon /> },
  ];

  return (
    <footer className="bg-primary text-white">
      <div className="container mx-auto px-4 py-6">
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-6">

          {/* --- Logo & Motto --- */}
          <div className="flex flex-col items-center md:items-start">
            <Link to="/" onClick={scrollToTop}>
              <img
                src="/images/logoB.png"
                alt="Anestar Victory Junior & Senior School Logo"
                className="w-32 h-auto mb-2 hover:scale-105 transition-transform duration-300"
              />
              <p className="text-sm text-center md:text-left">
                <span className="block font-bold text-center md:text-left">Proverbs 3:6</span>
                In everything you do, put God first, and he will direct you and crown your efforts with success.
              </p>
            </Link>
          </div>

          {/* --- Quick Links --- */}
          <div>
            <h3 className="text-lg font-bold mb-3">Quick Links</h3>
            <ul className="space-y-1 text-sm">
              {QUICK_LINKS.map((link) => (
                <li key={link.path}>
                  <Link
                    className="hover:text-white transition-colors text-slate-300"
                    to={link.path}
                    onClick={scrollToTop}
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* --- Contact --- */}
          <div>
            <h3 className="text-lg font-bold mb-3">Contact</h3>
            <ul className="space-y-1 text-sm text-slate-300">
              <li className="flex items-center gap-2">
                <span className="material-symbols-outlined text-base">location_on</span>
                <span>Lanet Ol-Kalou Rd, 273 NAKURU, KENYA</span>
              </li>
              <li className="flex items-center gap-2">
                <span className="material-symbols-outlined text-base">call</span>
                <span>+254 758887739, +254 712915099, +254 712977788</span>
              </li>
              <li className="flex items-center gap-2">
                <span className="material-symbols-outlined text-base">mail</span>
                <span>info@anestarjss.com</span>
              </li>
            </ul>
          </div>

          {/* --- Social --- */}
          <div>
            <h3 className="text-lg font-bold mb-3">Follow Us</h3>
            <div className="flex gap-3">
              {SOCIAL_LINKS.map((link) => (
                <a
                  key={link.label}
                  className="hover:text-white transition-transform transform hover:scale-110 text-slate-300"
                  href={link.href}
                  aria-label={link.label}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {link.icon}
                </a>
              ))}
            </div>
          </div>
        </div>

        {/* --- Footer Bottom --- */}
        <div className="mt-4 border-t border-primary/20 pt-4 text-center text-sm text-slate-300">
          <p>© {new Date().getFullYear()} Anestar Victory Junior & Senior School. All Rights Reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
